export const PRODUCTION_STATUS_LABELS: Record<string, string> = {
  not_started: "Not Started",
  ac: "AC",
  received: "Received",
  in_queue_a: "In Queue A",
  in_queue_b: "In Queue B",
  finishing: "Finishing",
  shelf_1: "Shelf 1",
  shelf_2: "Shelf 2",
  shelf_3: "Shelf 3",
  shelf_4: "Shelf 4",
  shelf_5: "Shelf 5",
  shelf_6: "Shelf 6",
  shelf_7: "Shelf 7",
  zone_1: "Zone 1",
  zone_2: "Zone 2",
  zone_3: "Zone 3",
  zone_4: "Zone 4",
  zone_5: "Zone 5",
  zone_6: "Zone 6",
  zone_7: "Zone 7",
  zone_8: "Zone 8",
  zone_9: "Zone 9",
  kfa_delivery: "KFA Delivery",
};

export const PRODUCTION_STATUS_STYLES: Record<string, { bg: string; color: string; border: string }> = {
  not_started: { bg: "#f8fafc", color: "#334155", border: "#e2e8f0" },
  ac: { bg: "#cffafe", color: "#155e75", border: "#67e8f9" },
  received: { bg: "#eef2ff", color: "#3730a3", border: "#c7d2fe" },
  in_queue_a: { bg: "#dbeafe", color: "#1d4ed8", border: "#bfdbfe" },
  in_queue_b: { bg: "#e0f2fe", color: "#0369a1", border: "#bae6fd" },
  finishing: { bg: "#fef9c3", color: "#854d0e", border: "#fde68a" },
  shelf_1: { bg: "#f0fdf4", color: "#166534", border: "#bbf7d0" },
  shelf_2: { bg: "#ecfdf5", color: "#047857", border: "#a7f3d0" },
  shelf_3: { bg: "#ccfbf1", color: "#0f766e", border: "#99f6e4" },
  shelf_4: { bg: "#ecfeff", color: "#0e7490", border: "#a5f3fc" },
  shelf_5: { bg: "#f5f3ff", color: "#6d28d9", border: "#ddd6fe" },
  shelf_6: { bg: "#faf5ff", color: "#7e22ce", border: "#e9d5ff" },
  shelf_7: { bg: "#fdf4ff", color: "#a21caf", border: "#f5d0fe" },
  zone_1: { bg: "#fff7ed", color: "#c2410c", border: "#fed7aa" },
  zone_2: { bg: "#fffbeb", color: "#b45309", border: "#fcd34d" },
  zone_3: { bg: "#f7fee7", color: "#4d7c0f", border: "#d9f99d" },
  zone_4: { bg: "#fef2f2", color: "#b91c1c", border: "#fecaca" },
  zone_5: { bg: "#fff1f2", color: "#be123c", border: "#fecdd3" },
  zone_6: { bg: "#fdf2f8", color: "#be185d", border: "#fbcfe8" },
  zone_7: { bg: "#fafafa", color: "#3f3f46", border: "#d4d4d8" },
  zone_8: { bg: "#fafaf9", color: "#57534e", border: "#d6d3d1" },
  zone_9: { bg: "#f0f9ff", color: "#0c4a6e", border: "#7dd3fc" },
  kfa_delivery: { bg: "#dcfce7", color: "#15803d", border: "#86efac" },
};

export const PRODUCTION_STATUS_OPTIONS = [
  { value: "not_started", label: "Not Started" },
  { value: "ac", label: "AC" },
  { value: "received", label: "Received" },
  { value: "in_queue_a", label: "In Queue A" },
  { value: "in_queue_b", label: "In Queue B" },
  { value: "finishing", label: "Finishing" },
  { value: "shelf_1", label: "Shelf 1" },
  { value: "shelf_2", label: "Shelf 2" },
  { value: "shelf_3", label: "Shelf 3" },
  { value: "shelf_4", label: "Shelf 4" },
  { value: "shelf_5", label: "Shelf 5" },
  { value: "shelf_6", label: "Shelf 6" },
  { value: "shelf_7", label: "Shelf 7" },
  { value: "zone_1", label: "Zone 1" },
  { value: "zone_2", label: "Zone 2" },
  { value: "zone_3", label: "Zone 3" },
  { value: "zone_4", label: "Zone 4" },
  { value: "zone_5", label: "Zone 5" },
  { value: "zone_6", label: "Zone 6" },
  { value: "zone_7", label: "Zone 7" },
  { value: "zone_8", label: "Zone 8" },
  { value: "zone_9", label: "Zone 9" },
  { value: "kfa_delivery", label: "KFA Delivery" },
];

export const getProductionStatusMeta = (rawStatus: unknown) => {
  const key = String(rawStatus || "not_started").trim().toLowerCase() || "not_started";
  const normalized = key in PRODUCTION_STATUS_STYLES ? key : "not_started";
  return {
    key: normalized,
    label: PRODUCTION_STATUS_LABELS[normalized] || "Not Started",
    style: PRODUCTION_STATUS_STYLES[normalized],
  };
};
